import { createSlice } from "@reduxjs/toolkit";

const empresaSlice = createSlice({
    name: 'empresa',
    initialState: {
        empresas: [],
        empresaIndividual: []
    },
    reducers: {
        addEmpresa: (state, action) => {
            state.empresas = action.payload;
        },
        addEmpresaIndividual: (state, action) => {
            state.empresaIndividual = action.payload
        },
    }
});

export const { addEmpresa, addEmpresaIndividual } = empresaSlice.actions;
export default empresaSlice.reducer;